import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useState } from "react";
import { kpiDetails } from "./../data";
import React from 'react';

const KPIDetails = ({ dataPassed }) => {
  const [expandedPanel, setExpandedPanel] = useState(dataPassed.name);

  const handleChange = (panelName) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panelName : false);
  };

  return (
    <div>
      {kpiDetails.map((kpiDetail) => {
        return (
          <ExpansionPanel
            expanded={expandedPanel === kpiDetail.name}
            onChange={handleChange(kpiDetail.name)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{kpiDetail.name}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography>{kpiDetail.summary}</Typography>
              <Typography>{kpiDetail.detail}</Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      })}
    </div>
  );
};

export default KPIDetails;
